import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

/**
 * Base API for XTM Go. Features inject their own endpoints via `injectEndpoints`.
 *
 * The bearer token is attached by `baseQueryWithReauth`, which also handles
 * 401 (silent renew + retry, else re-login) and 403 (forbidden flag).
 */
export const expressApi = createApi({
  reducerPath: 'expressApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Documents', 'RiskAnalysis', 'TranslationJobs', 'User', 'XtmCloudConfig', 'XtmCloudCustomers', 'XtmCloudTemplates', 'TranslatedBatches', 'LlmConnectors', 'LlmConfig', 'StyleGuides'],
  endpoints: () => ({}),
});
